import firebase from "firebase/compat/app";
import "firebase/compat/database";

const firebaseConfig2 = {
  apiKey: "AIzaSyBOZ5HHgk3mTi5JWJrnr-3BXbNkF6_yl5s",
  authDomain: "arduinocontrol-d18da.firebaseapp.com",
  databaseURL: "https://arduinocontrol-d18da-default-rtdb.firebaseio.com",
  projectId: "arduinocontrol-d18da",
  storageBucket: "arduinocontrol-d18da.appspot.com",
  messagingSenderId: "315728694110",
  appId: "1:315728694110:web:0d574e4c8af70aa10b5dcf",
};

firebase.initializeApp(firebaseConfig2);

export default firebase.database();
